import gql from 'graphql-tag';

const UPDATE_FIRMWARE = gql`
  mutation Mutation($deviceSerialNo: String!, $firmware: String!) {
    updateFirmware(deviceSerialNo: $deviceSerialNo, firmware: $firmware) {
      code
    }
  }
`;

export default UPDATE_FIRMWARE;
